import(/* webpackMode: "eager", webpackExports: ["FadeIn"] */ "/vercel/path0/platforms/api/apps/dashboard/components/landing/fade-in.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/vercel/path0/platforms/api/apps/dashboard/components/ui/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/vercel/path0/platforms/api/apps/dashboard/components/ui/separator.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/platforms/api/node_modules/.pnpm/next@14.2.30_@babel+core@7.28.0_@opentelemetry+api@1.4.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
